import React from 'react';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import { HOME_LOANS_NEW } from 'types/morph.pagePosition.constants';
import { MORTGAGE_VERTICAL } from 'types/mrph.vertical.constants';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import useHomeLoan from '../hooks/homeLoan.hook';
import NewHomeMarketplaceModuleView from './NewHomeMarketplaceModuleView';
import $t from 'locales/en/translation';

const NewHomeMarketplaceModuleController = props => {
  const { eventHandler, globalLoadingFlag } = props;
  const homeLoanPageState = useHomeLoan(eventHandler, 'PURCHASE');

  const loading = globalLoadingFlag;

  const trackingAtr = getViewModuleTrackingAttributes({
    moduleName: HOME_LOANS_NEW,
    modulePosition: props.modulePosition,
    vertical: MORTGAGE_VERTICAL,
  });

  useViewModule(trackingAtr, !loading);

  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  if (loading) {
    return <PageLoadingMask />;
  } else {
    return (
      <>
        <NewHomeMarketplaceModuleView
          seenPixel={seenModuleTracking}
          {...props}
          {...homeLoanPageState}
          pagePosition={HOME_LOANS_NEW}
          offerMessage={$t.yourCustomizedRates}
        />
      </>
    );
  }
};

export default NewHomeMarketplaceModuleController;
